export default __webpack_public_path__ + "img/66.af7129f.svg";